import { type MCPServerInfo } from '../../types';

const WizServer: MCPServerInfo = {
  serverId: 'WIZ',
  name: 'Wiz',
  slug: 'wiz',
  description:
    'Wiz cloud security platform MCP Server with comprehensive security, compliance, and cost optimization tools',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.app.wiz.io/'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default WizServer;
